<template>
    <MainContent 
        title='Crear nueva liquidación'
    >
        <template v-slot:header>
            <RecordatorioTituloComponent v-if="terminado" />
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <ValidationObserver v-if="! terminado" tag="form" ref="observerLiquidacion" @submit.prevent="submitFirstStep()">
                    <div class="row" v-if="!loading">
                        <div class="col-12 col-lg-6">
                            <div class="form-group">
                                <label for="fechas">Selecciona el rango de fechas:</label>
                                <DatePickerRanger
                                    :dateRange="data"
                                    :maxDate="maxDate"
                                    :minDate="minDate"
                                    :disabledDates="disabledDates"
                                    :disabled="creando"
                                    @selected="selectedOption => { data = selectedOption }"
                                />
                                <span v-if="errorFechas" class="error">El campo rango de fechas es requerido</span>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-group">
                                <label for="datos_fiscales">Seleccionar datos fiscales:</label>
                                <ValidationProvider name="direcciones fiscales" rules="required" mode="passive" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.direccionFiscal"
                                        :show-labels="false"
                                        :options="direccionesFiscales"
                                        :allow-empty="false"
                                        label="nombre"
                                        :class="(errors[0] ? 'is-invalid' : '')"
                                        placeholder="Seleccione unos datos fiscales"
                                        :disabled="creando"
                                    />
                                    <span class="error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <DatosFiscales
                            v-if="data.direccionFiscal"
                            :direccionFiscal.sync="data.direccionFiscal"
                            :disabled="creando || resumen !== null"
                        />

                        <ResumenProvisional
                            :resumen="resumen"
                            :creando="creando"
                            :total="total"
                            @crearLiquidacion="crearLiquidacion"
                        >
                            <div class="col-12 col-lg-6">
                                <div class="row">
                                    <div class="col-12 ml-3">
                                        <h5>Parcelas</h5>
                                        <ul>
                                            <li>Total de parcelas: {{ resumen?.transacciones?.total }}</li>
                                            <li>Importe total: {{ resumen?.transacciones?.importe | formatear_precio }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="row">
                                    <div class="col-12 ml-3">
                                        <h5>Devoluciones</h5>
                                        <ul>
                                            <li>Total de devoluciones: {{ resumen?.devoluciones?.total }}</li>
                                            <li>Importe total: {{ resumen?.devoluciones?.importe | formatear_precio }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="row">
                                    <div class="col-12 ml-3">
                                        <h5>Comisiones para pedidos de más de 25€</h5>
                                        <ul>
                                            <li>Total de pedidos: {{ resumen?.comisiones.mas_25?.total }}</li>
                                            <li>Importe total: {{ resumen?.comisiones?.mas_25?.importe | formatear_precio }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="row">
                                    <div class="col-12 ml-3">
                                        <h5>Comisiones para pedidos de menos de 25€</h5>
                                        <ul>
                                            <li>Total de pedidos: {{ resumen?.comisiones?.menos_25?.total }}</li>
                                            <li>Importe total: {{ resumen?.comisiones?.menos_25?.importe | formatear_precio }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6" v-if="resumen?.gg_internos?.total">
                                <div class="row">
                                    <div class="col-12 ml-3">
                                        <h5>Gastos de gestión</h5>
                                        <ul>
                                            <li>Total de parcelas: {{ resumen?.gg_internos?.total }}</li>
                                            <li>Importe total: {{ resumen?.gg_internos?.importe | formatear_precio }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </ResumenProvisional>
                    </div>
                </ValidationObserver>
                <RecordatorioComponent
                    v-else
                    @continuar="continuar"
                />
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import DatePickerRanger from '@/components/common/forms/DatePickerRanger';
    import RecordatorioComponent from '@/components/backend/liquidaciones/common/RecordatorioComponent.vue';
    import RecordatorioTituloComponent from '@/components/backend/liquidaciones/common/RecordatorioTituloComponent.vue';
    import ResumenProvisional from '@/components/backend/liquidaciones/common/ResumenProvisional.vue';
    import DatosFiscales from '@/components/backend/liquidaciones/common/DatosFiscales.vue';

    export default {
        data() {
            return {
                data: {},
                url: this.config.API_BASE,
                maxDate: moment().subtract(1, 'days').format('L'),
                minDate: '05/01/2025',
                disabledDates: [],
                loading: true,
                direccionesFiscales: [],
                resumen: null,
                errorFechas: false,
                terminado: false,
                creando: false
            }
        },
        created() {
            this.getDisabledDates();
            this.getDireccionesFiscales();
        },
        methods: {
            getDisabledDates() {
                const params = {
                    filters : {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.parcelas.last.date'), params).then(res => {
                    this.disabledDates = res.data.fechas;
                }).finally(() => {
                    this.loading = false;
                });
            },
            getDireccionesFiscales() {
                const params = {
                    filters : {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.direcciones.fiscales.index'), params).then(res => {
                    this.direccionesFiscales = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });                
            },
            async submitFirstStep() {
                const isValid = await this.$refs.observerLiquidacion.validate();
                if(isValid && this.data.endDate && this.data.startDate) {
                    this.errorFechas = false;
                    this.getResumenLiquidacion();
                } else {
                    if(! this.data.endDate || ! this.data.startDate) {
                        this.errorFechas = true;
                    }
                    this.scrollTo(".is-invalid");
                }
            },
            getResumenLiquidacion() {
                this.data.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.parcelas.resumen'), this.data).then(res => {
                    this.resumen = res.data;
                    this.scrollTo('#resumen');
                }).catch(error => {
                    this.resumen = null;
                    this.$toast.error(error.response.data.message);
                });   
            },
            crearLiquidacion() {
                this.creando = true;
                this.data.filters = {};

                const payload = {
                    ...this.data,
                    direccionFiscal: this.data.direccionFiscal?.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.parcelas.crear'), payload).then(res => {
                    this.$toast.success(res.data.message);
                    this.terminado = true;
                    this.creando = false;                 
                });
            },
            continuar() {
                this.$router.push({ name: 'back.liquidaciones.parcelas.index' });
            },
            scrollTo(paso) {
                this.$nextTick(() => {
                    this.$scrollTo(paso, 100);
                });
            }
        },
        computed: {
            total() {
                return this.resumen?.transacciones?.importe + this.resumen?.devoluciones?.importe + this.resumen?.comisiones?.mas_25?.importe + this.resumen?.comisiones?.menos_25?.importe + (this.resumen?.gg_internos?.importe ? this.resumen?.gg_internos?.importe : 0);
            }
        },
        components: {
            MainContent,
            ContentOrLoading,
            DatePickerRanger,
            RecordatorioComponent,
            RecordatorioTituloComponent,
            ResumenProvisional,
            DatosFiscales
        }
    }
</script>